import React, { createContext, useMemo, useCallback, useContext, useState } from 'react';
import { distributorService } from '../services/DistributorService';

export const DistributorContext = createContext();

export const DistributorProvider = props => {
    const [distributors, setDistributors] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sortState, setSortState] = useState([{ fieldName: 'Name', dir: 'asc' }])

    const createDistributor = useCallback((name, notes, address, city, state, zip, pricingMultiplier) => {
        return distributorService.postDistributor(name, notes, address, city, state, zip, pricingMultiplier);
    }, []);

    const getDistributors = useCallback(async () => {
        const result = await distributorService.getDistributors(pageSize, pageIndex, sortState[0]?.fieldName, sortState[0]?.dir);
        setDistributors(result.data);
        setTotal(result?.total);
        return result;
    }, [pageSize, pageIndex, sortState]);

    const getAllDistributors = useCallback(async () => {
        const result = await distributorService.getDistributors(null, null, 'name', 'asc');
        return result;
    }, []);

    const getDistributorById = useCallback(id => {
        return distributorService.getDistributorById(id);
    }, []);

    const editDistributor = useCallback((id, name, notes, address, city, state, zip, pricingMultiplier) => {
        return distributorService.putDistributor(id, name, notes, address, city, state, zip, pricingMultiplier);
    }, []);

    const uploadLogo = useCallback((distributorId, fileName, image) => {
        return distributorService.uploadLogo(distributorId, fileName, image);
    }, []);

    const deleteDistributor = useCallback((id) => {
        return distributorService.deleteDistributor(id);
    }, []);

    const values = useMemo(
        () => ({
            distributors,
            total,
            pageIndex,
            pageSize,
            sortState,
            createDistributor,
            getDistributors,
            getAllDistributors,
            getDistributorById,
            editDistributor,
            uploadLogo,
            deleteDistributor,
            setPageIndex,
            setPageSize,
            setSortState
        }),
        [
            distributors,
            total,
            pageIndex,
            pageSize,
            sortState,
            createDistributor,
            getDistributors,
            getAllDistributors,
            getDistributorById,
            editDistributor,
            uploadLogo,
            deleteDistributor,
            setPageIndex,
            setPageSize,
            setSortState
        ]
    );

    return <DistributorContext.Provider value={values}>{props.children}</DistributorContext.Provider>;
};

export const useDistributors = () => {
    const context = useContext(DistributorContext);

    if (context === undefined) {
        throw new Error('useDistributors must be used within a DistributorProvider component.');
    }

    return context;
};
